import React from "react";
import ServiceCard from "./ServiceCard";
import "./WhatWeDo.css";

const services = [
  {
    icon: "🧠",
    title: "AI & Innovation Advisory",
    description:
      "We help organizations identify, design, and apply AI solutions that are commercially meaningful, operationally realistic, and strategically aligned."
  },
  {
    icon: "📈",
    title: "Marketing Consultancy",
    description:
      "We support brand, growth, and communications decisions through marketing strategy, digital planning, media guidance, and web-oriented execution."
  },
  {
    icon: "♟️",
    title: "Advisory & Business Strategy",
    description:
      "We advise leadership teams on business planning, organizational priorities, project execution, and strategic transformation."
  },
  {
    icon: "🔎",
    title: "Research & Insight Generation",
    description:
      "We use structured analysis, market understanding, and evidence-based research to support better decisions in complex or fast-changing environments."
  }
];

const WhatWeDo = () => {
  return (
    <section className="what-section">
      <div className="container">
        <div className="section-header">
          <h2>What We Do</h2>
          <p>
            We support companies, founders, and leadership teams across four core areas:
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;